// Build identity for observability (rootcause FIX C).
//
// `__APP_BUILD_ID__` is a compile-time define injected by vite.config.ts
// (commit SHA in CI, `git rev-parse` locally, 'dev' otherwise). The typeof
// guard keeps every runtime that does NOT go through the Vite define —
// vitest workers, tooling imports — on a safe 'dev' fallback instead of a
// ReferenceError.
//
// This exists because the 2026-07-13 M02 fan-out investigation could not
// determine which bundle the reporting device ran: Sentry events carried no
// release, `source_device_id` is null fleet-wide, and the stale-bundle
// hypothesis had to be dis/confirmed the hard way (prod id forensics). Every
// Sentry event now carries the build in both the `release` and the
// `client_build` tag (lib/sentry.ts).

export const APP_BUILD_ID: string =
  typeof __APP_BUILD_ID__ !== 'undefined' ? __APP_BUILD_ID__ : 'dev'
